module.exports = __webpack_public_path__ + "img/LouisFace.42e4a030.jpg";